export function colRowToHash(col: number, row: number): string {
  return `${col}x${row}`;
}

export function hashToColRow(hash: string): [number, number] {
  const array = hash.split('x').map(Number);
  return [array[0], array[1]];
}